export default __webpack_public_path__ + "static/media/amex.3ba229ee.png";